import { useEffect, useState } from "react";
import {
  AccessTokenClaims,
  buildCurrentUserData,
  getAuth0TokenClaims,
  Person,
  tokenManager,
} from "@inductiveautomation/ws-components";
import { useGetProfileQuery } from "../routes/Profile/api/profile.api";

export interface CurrentUserInformation {
  isLoading: boolean;
  user?: Person & { claims?: AccessTokenClaims };
  token?: string | null;
}

export const useCurrentUser = (): CurrentUserInformation => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    tokenManager.refreshToken()
      .then((newToken)=>{setToken(newToken as string);})
      .catch((reason: unknown) => console.error("Failed to refresh token", reason));
  }, []);

  const { data, isLoading } = useGetProfileQuery(undefined, { skip: !token });

  const claims = token ? getAuth0TokenClaims(token) : undefined;

  if (!data) {
    if (isLoading) return { isLoading: true };

    return { isLoading: false, user: undefined, token };
  }

  return {
    isLoading,
    user: buildCurrentUserData(data, claims),
    token,
  };
};
